import { useSelector } from "react-redux";
import { lazy, Suspense } from "react";

import * as wheelSelector from "redux/landing/wheels/selectors";
import { WheelType } from "types/Wheel";

const LazyDiskGirl = lazy(() => import("components/molecules/DiskGirl"));
const LazyDiskTeenagers = lazy(
  () => import("components/molecules/DiskTeenagers"),
);
const LazyDiskCards = lazy(() => import("components/molecules/DiskCards"));

const LazyDiskAviator = lazy(() => import("components/molecules/DiskAviator"));
const LazyDiskChicks = lazy(() => import("components/molecules/DiskChicks"));
const LazyDiskCrazyTime = lazy(
  () => import("components/molecules/DiskCrazyTime"),
);
const LazyDiskOlympus = lazy(() => import("components/molecules/DiskOlympus"));
const LazyDiskRoulette = lazy(
  () => import("../../components/molecules/DiskRoulette"),
);
const LazyDiskBonanza = lazy(
  () => import("../../components/molecules/DiskBonanza"),
);

const DiskContainer = () => {
  const { angle, type, attempts } = useSelector(wheelSelector.all);

  return (
    <>
      {type === WheelType.GIRLS_BANGLADESH && (
        <Suspense fallback="">
          <LazyDiskGirl angle={angle} />
        </Suspense>
      )}
      {type === WheelType.GIRLS && (
        <Suspense fallback="">
          <LazyDiskGirl angle={angle} />
        </Suspense>
      )}
      {type === WheelType.TEENAGERS && (
        <Suspense fallback="">
          <LazyDiskTeenagers angle={angle} />
        </Suspense>
      )}
      {type === WheelType.CARDS && (
        <Suspense fallback="">
          <LazyDiskCards angle={angle} />
        </Suspense>
      )}
      {type === WheelType.AVIATOR && (
        <Suspense fallback="">
          <LazyDiskAviator angle={angle} />
        </Suspense>
      )}
      {type === WheelType.CRAZY_TIME && (
        <Suspense fallback="">
          <LazyDiskCrazyTime angle={angle} />
        </Suspense>
      )}
      {(type === WheelType.CHICKS_TURKEY ||
        type === WheelType.CHICKS_BANGLADESH ||
        type === WheelType.CHICKS_AZER ||
        type === WheelType.CHICKS_UZBEKISTAN) && (
        <Suspense fallback="">
          <LazyDiskChicks angle={angle} />
        </Suspense>
      )}
      {type === WheelType.ROULETTE && (
        <Suspense fallback="">
          <LazyDiskRoulette angle={angle} />
        </Suspense>
      )}
      {type === WheelType.SWEET_BONANZA && (
        <Suspense fallback="">
          <LazyDiskBonanza angle={angle} attempts={attempts} />
        </Suspense>
      )}
      {type === WheelType.GATES_OLYMPUS && (
        <Suspense fallback="">
          <LazyDiskOlympus angle={angle} attempts={attempts} />
        </Suspense>
      )}
    </>
  );
};

export default DiskContainer;
